import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=5bf5e4d5&scoped=true&"
var script = {}
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=5bf5e4d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5e4d5",
  null
  
)

export default component.exports